import './Tutorials.scss';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FortnoxLogo from '../../../Images/Logos/fortnox-svg.svg';
import VismaLogo from '../../../Images/Logos/Visma_spcs_logo.svg';
import BjornLundenLogo from '../../../Images/Logos/Bjorn-Lunden-logo.png';
import SKVLogo from '../../../Images/Logos/SKV_RGB_li.png';
import FortnoxImg1 from '../../../Images/Tutorials/Fortnox/License/Fortnox_integration_1.png';
import FortnoxImg2 from '../../../Images/Tutorials/Fortnox/License/Fortnox_integration_2.png';
import FortnoxImg3 from '../../../Images/Tutorials/Fortnox/License/Fortnox_integration_3.png';
import FortnoxImg4 from '../../../Images/Tutorials/Fortnox/License/Fortnox_integration_4.png';
import VismaLic1 from '../../../Images/Tutorials/Visma/License/Visma_integration_1.png';
import VismaLic2 from '../../../Images/Tutorials/Visma/License/Visma_integration_2.png';
import VismaLic3 from '../../../Images/Tutorials/Visma/License/Visma_integration_3.png';
import VismaLic4 from '../../../Images/Tutorials/Visma/License/Visma_integration_4.png';
import VismaLic5 from '../../../Images/Tutorials/Visma/License/Visma_integration_5.png';
import VismaCom1 from '../../../Images/Tutorials/Visma/StandardCompany/Visma_standardföretag_1.png';
import VismaCom2 from '../../../Images/Tutorials/Visma/StandardCompany/Visma_standardföretag_2.png';
import VismaCom3 from '../../../Images/Tutorials/Visma/StandardCompany/Visma_standardföretag_3.png';
import VismaCom4 from '../../../Images/Tutorials/Visma/StandardCompany/Visma_standardföretag_4.png';
import VismaCom5 from '../../../Images/Tutorials/Visma/StandardCompany/Visma_standardföretag_5.png';
import BLKey1 from '../../../Images/Tutorials/BL/BL_key_1.png';
import BLKey2 from '../../../Images/Tutorials/BL/BL_key_2.png';
import BLKey3 from '../../../Images/Tutorials/BL/BL_key_3.png';
import SKVImg1 from '../../../Images/Tutorials/SKV/SKV_integration_1.png';
import SKVImg2 from '../../../Images/Tutorials/SKV/SKV_integration_2.png';
import SKVImg3 from '../../../Images/Tutorials/SKV/SKV_integration_3.png';
import SKVImg4 from '../../../Images/Tutorials/SKV/SKV_integration_4.png';

/* eslint-disable react/prop-types */
function SystemButton({ selected, onClick, logo }) {
  return (
    <button
      className={`tutorial-nav-button ${selected ? 'selected-nav-button' : ''}`}
      type="button"
      onClick={onClick}
    >
      <img className="partner-logo" src={logo} alt="LOGO" />
    </button>
  );
}

function TutorialButton({ title, onClick, selected }) {
  return (
    <button
      className={`tutorial-button ${
        selected ? 'selected-tutorial-button' : ''
      }`}
      type="button"
      onClick={onClick}
    >
      {title}
    </button>
  );
}

export default function Tutorials() {
  const [selectedSystem, setSelectedSystem] = useState('Fortnox');
  const [selectedTutorial, setSelectedTutorial] = useState(0);

  const { search } = useLocation();

  useEffect(() => {
    const as = new URLSearchParams(search).get('as');
    if (as === null) {
      return;
    }

    if (as === 'fortnox') {
      setSelectedTutorial(0);
      setSelectedSystem('Fortnox');
    } else if (as === 'visma') {
      setSelectedTutorial(0);
      setSelectedSystem('Visma');
    } else if (as === 'bl') {
      setSelectedTutorial(0);
      setSelectedSystem('BL');
    } else if (as === 'skv') {
      setSelectedTutorial(0);
      setSelectedSystem('SKV');
    }
  }, [search]);

  const fortnoxTutorials = [
    {
      id: 0,
      tutorialContent: [
        { img: FortnoxImg1, index: 0 },
        { img: FortnoxImg2, index: 1 },
        { img: FortnoxImg3, index: 2 },
        { img: FortnoxImg4, index: 3 },
      ],
    },
  ];

  const vismaTutorials = [
    {
      id: 0,
      tutorialContent: [
        { img: VismaLic1, index: 0 },
        { img: VismaLic2, index: 1 },
        { img: VismaLic3, index: 2 },
        { img: VismaLic4, index: 3 },
        { img: VismaLic5, index: 4 },
      ],
    },
    {
      id: 1,
      tutorialContent: [
        { img: VismaCom1, index: 0 },
        { img: VismaCom2, index: 1 },
        { img: VismaCom3, index: 2 },
        { img: VismaCom4, index: 3 },
        { img: VismaCom5, index: 4 },
      ],
    },
  ];

  const BLTutorials = [
    {
      id: 0,
      tutorialContent: [
        { img: BLKey1, index: 0 },
        { img: BLKey2, index: 1 },
        { img: BLKey3, index: 2 },
      ],
    },
  ];

  const SKVTutorials = [
    {
      id: 0,
      tutorialContent: [
        { img: SKVImg1, index: 0 },
        { img: SKVImg2, index: 1 },
        { img: SKVImg3, index: 2 },
        { img: SKVImg4, index: 3 },
      ],
    },
  ];

  const selectedImages =
    selectedSystem === 'Fortnox'
      ? fortnoxTutorials[selectedTutorial].tutorialContent
      : selectedSystem === 'Visma'
      ? vismaTutorials[selectedTutorial].tutorialContent
      : selectedSystem === 'BL'
      ? BLTutorials[selectedTutorial].tutorialContent
      : selectedSystem === 'SKV'
      ? SKVTutorials[selectedTutorial].tutorialContent
      : [];

  return (
    <div className="tutorials-wrapper">
      <div className="tutorial-header">
        <div className="tutorial-accounting-nav">
          <SystemButton
            logo={FortnoxLogo}
            selected={selectedSystem === 'Fortnox'}
            onClick={() => {
              setSelectedTutorial(0);
              setSelectedSystem('Fortnox');
            }}
          />
          <SystemButton
            logo={VismaLogo}
            selected={selectedSystem === 'Visma'}
            onClick={() => {
              setSelectedTutorial(0);
              setSelectedSystem('Visma');
            }}
          />
          <SystemButton
            logo={BjornLundenLogo}
            selected={selectedSystem === 'BL'}
            onClick={() => {
              setSelectedTutorial(0);
              setSelectedSystem('BL');
            }}
          />
          <SystemButton
            logo={SKVLogo}
            selected={selectedSystem === 'SKV'}
            onClick={() => {
              setSelectedTutorial(0);
              setSelectedSystem('SKV');
            }}
          />
        </div>
        <div className="tutorial-selection-nav">
          {selectedSystem === 'Fortnox' ? (
            <TutorialButton
              title="Integrationslicens"
              onClick={() => {
                setSelectedTutorial(0);
              }}
              selected={selectedTutorial === 0}
            />
          ) : selectedSystem === 'Visma' ? (
            <>
              <TutorialButton
                title="Integrationslicens"
                onClick={() => {
                  setSelectedTutorial(0);
                }}
                selected={selectedTutorial === 0}
              />
              <TutorialButton
                title="Standardföretag"
                onClick={() => {
                  setSelectedTutorial(1);
                }}
                selected={selectedTutorial === 1}
              />
            </>
          ) : selectedSystem === 'BL' ? (
            <TutorialButton
              title="Publik nyckel"
              onClick={() => {
                setSelectedTutorial(0);
              }}
              selected={selectedTutorial === 0}
            />
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="tutorial-content">
        {selectedImages.map((data) => {
          return (
            <img
              className="tutorial-image"
              src={data.img}
              alt="TutorialImage"
              key={data.index}
            />
          );
        })}
      </div>
    </div>
  );
}
